import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../../shared/store";
import { BundlePdpApp } from "./BundlePdpApp";
import type { BundlePdpConfig } from "./types";

function readConfig(configId: string): BundlePdpConfig {
  const configEl = document.getElementById(configId);

  if (!configEl?.textContent) {
    throw new Error(`Missing Bundle PDP config: ${configId}`);
  }

  return JSON.parse(configEl.textContent) as BundlePdpConfig;
}

document
  .querySelectorAll<HTMLElement>("[data-bundle-pdp-root]")
  .forEach((rootEl) => {
    if (rootEl.dataset.reactMounted === "true") return;

    const configId = rootEl.dataset.configId;
    if (!configId) return;

    rootEl.dataset.reactMounted = "true";

    createRoot(rootEl).render(
      <React.StrictMode>
        <Provider store={store}>
          <BundlePdpApp config={readConfig(configId)} />
        </Provider>
      </React.StrictMode>,
    );
  });
